export const GEO_CITY = 'GEO_CITY';
export const GEO_ASN = 'GEO_ASN';
export const SESSION = 'SESSION';
export const SESSION_PER_PAGE = 200;
export const MAX_ANCHORED_COUNT = 3;
